<template>
  <div class="subsys-userform-view" v-show="isShow"></div>
</template>

<script>
export default {
  name: "SubsysView",
  data() {
    return {
      isShow: true,
    };
  },
  computed: {
    CurUserForm() {
      return CmnMis.CurUserForm;
    },
  },
  watch: {
    $route: {
      handler(route, oldRoute) {
        if (route.params.sysguid !== oldRoute.params.sysguid) {
          // this.isShow = false;
        }
      },
    },
  },
  methods: {
    LoadUserFormView() {
      setTimeout(()=>{
        this.$emit("OnMount");
      }, 0);
    },
  },
};
</script>
